const question1 = {
    'question': 'Czym jest porada psychologiczna?',
    'answer': 'Porada psychologiczna to spotkanie z psychologiem, podczas którego osoba poszukująca pomocy może porozmawiać o swoich problemach i trudnościach. Psycholog pomaga osobie zrozumieć jej emocje, myśli i zachowania, a także w rozwoju umiejętności radzenia sobie z trudnymi sytuacjami.',
}

export default question1;